import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[uiBurgerAside]',
})
export class UiHeaderBurgerAsideDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
